import { AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, Input, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-app-modal',
  templateUrl: './app-modal.component.html',
  styleUrls: ['./app-modal.component.css']
})
export class AppModalComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input()
  title: string = "";
  @ViewChild('bodyHost', { read: ViewContainerRef }) bodyHost!: ViewContainerRef;
  @Input() componentFactory: ComponentFactory<any>;
  @Input() componentInputs: any;
  @Input() templateRef?: TemplateRef<any>;
  private componentRef: ComponentRef<any> | null = null;

  @Input() cleanupFunction?: () => void;

  constructor(
    private activeModal: NgbActiveModal,
    private cfr: ComponentFactoryResolver
  ) { }

  ngOnInit() {

  }

  ngAfterViewInit() {
    if (this.templateRef) {
      this.bodyHost.createEmbeddedView(this.templateRef);
    }

    if (this.componentFactory) {
      this.componentRef = this.bodyHost.createComponent(this.componentFactory);

      // Pass inputs to the injected component
      if (this.componentInputs) {
        Object.assign(this.componentRef.instance, this.componentInputs);
      }
      this.componentRef.changeDetectorRef.detectChanges();
    }
  }

  closeModal() {
    this.activeModal.close()
  }

  ngOnDestroy() {
    if (this.cleanupFunction) {
      this.cleanupFunction();
    }
  }
}
